import { useEffect, useRef, useState } from "react";
import { Music, Waves, VolumeX, Play, Pause } from "lucide-react";

const MUSIC = [
  { id: "energica", label: "Energica", hint: "118 BPM", icon: Music, src: "/media/music/energica.m4a" },
  { id: "chill", label: "Chill", hint: "84 BPM", icon: Waves, src: "/media/music/chill.m4a" },
  { id: "nessuna", label: "Nessuna", hint: "Solo voce", icon: VolumeX },
];

const Bars = () => (
  <span className="flex h-3.5 items-end gap-[2px]" aria-hidden>
    {[0, 1, 2].map((b) => (
      <span key={b} className="eq-bar h-full w-[3px] rounded-full bg-[#0066FF]" style={{ animationDelay: `${b * 0.15}s` }} />
    ))}
  </span>
);

export const MusicPicker = ({ value, onChange, disabled }) => {
  const audio = useRef(null);
  const [playing, setPlaying] = useState(null);

  useEffect(() => {
    return () => {
      if (audio.current) audio.current.pause();
    };
  }, []);

  const toggle = (m) => {
    if (audio.current) audio.current.pause();
    if (playing === m.id) {
      setPlaying(null);
      return;
    }
    audio.current = new Audio(m.src);
    audio.current.volume = 0.7;
    audio.current.onended = () => setPlaying(null);
    audio.current.play().then(() => setPlaying(m.id)).catch(() => setPlaying(null));
    if (!disabled) onChange(m.id);
  };

  return (
    <div className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-3" data-testid="music-picker">
      {MUSIC.map((m) => {
        const active = value === m.id;
        const Icon = m.icon;
        return (
          <div key={m.id} className="relative">
            <button type="button" onClick={() => !disabled && onChange(m.id)} data-testid={`music-option-${m.id}`}
              className={`flex w-full items-center gap-3 rounded-2xl border p-4 pr-14 text-left transition-[border-color,background-color,transform] duration-200 hover:-translate-y-0.5 ${active ? "border-[#0066FF] bg-[#0066FF]/[0.06] ring-1 ring-[#0066FF]" : "border-[#e7e7ea] bg-white hover:border-[#c7c7cc]"}`}>
              {playing === m.id ? <Bars /> : <Icon className={`h-5 w-5 shrink-0 ${active ? "text-[#0066FF]" : "text-[#52525b]"}`} />}
              <span className="flex flex-col">
                <span className="text-sm font-semibold">{m.label}</span>
                <span className="text-xs text-[#52525b]">{m.hint}</span>
              </span>
            </button>
            {m.src && (
              <button type="button" onClick={() => toggle(m)} aria-label={playing === m.id ? `Ferma ${m.label}` : `Ascolta ${m.label}`}
                className={`absolute right-3 top-1/2 grid h-9 w-9 -translate-y-1/2 place-items-center rounded-full transition-[transform,background-color] duration-200 hover:scale-110 ${playing === m.id ? "bg-[#0066FF] text-white" : "bg-[#111111] text-white"}`}
                data-testid={`music-preview-${m.id}`}>
                {playing === m.id ? <Pause className="h-4 w-4" /> : <Play className="ml-0.5 h-4 w-4" />}
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};
